import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/loader.gif'
import _imports_1 from '@/assets/imgs/chip_selector.png'
import _imports_2 from '@/assets/imgs/chipsc.webp'
import _imports_3 from '@/assets/imgs/chipsc.png'
import _imports_4 from '@/assets/imgs/chips_seting_btn.webp'
import _imports_5 from '@/assets/imgs/chips_seting_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3b2d0592")

_pushScopeId("data-v-3b2d0592")
const _hoisted_1 = _imports_2
const _hoisted_2 = _imports_4
const _hoisted_3 = { class: "mobile-desk-root" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon icon-menu" }, null, -1)
const _hoisted_7 = { class: "info-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon icon-user" }, null, -1)
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "info-2" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "setting" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_14 = { class: "main-section" }
const _hoisted_15 = { class: "video-wrap" }
const _hoisted_16 = /*#__PURE__*/_createVNode("canvas", {
  id: "videoplayer2",
  class: "player"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("canvas", {
  id: "videoplayer1",
  class: "player"
}, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "loading"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("picture", null, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_20 = { class: "timer-status" }
const _hoisted_21 = { class: "status" }
const _hoisted_22 = { class: "shoe-ju" }
const _hoisted_23 = { class: "shoe-ju" }
const _hoisted_24 = { class: "bet-view-chip-and-info-wrap" }
const _hoisted_25 = { class: "chip-list" }
const _hoisted_26 = {
  key: 0,
  src: _imports_1,
  class: "active",
  alt: ""
}
const _hoisted_27 = { class: "chip-container" }
const _hoisted_28 = {
  key: 0,
  src: _imports_1,
  class: "active",
  alt: ""
}
const _hoisted_29 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_1
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/chipsc.png"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("source", {
  type: "image/webp",
  srcset: _hoisted_2
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  "data-was-processed": "true",
  "data-src": "~@/assets/imgs/chips_seting_btn.png",
  draggable: "false"
}, null, -1)
const _hoisted_33 = { class: "map" }
const _hoisted_34 = { class: "m-map-info-sum" }
const _hoisted_35 = { class: "m-roadmap-summary-wrap" }
const _hoisted_36 = { class: "m-roadmap-summary-item" }
const _hoisted_37 = { class: "m-red" }
const _hoisted_38 = { class: "m-roadmap-summary-item" }
const _hoisted_39 = { class: "m-blue" }
const _hoisted_40 = { class: "m-roadmap-summary-item" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "green" }, "和", -1)
const _hoisted_42 = {
  key: 0,
  class: "m-roadmap-summary-item"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "m-red pair" }, "庄对", -1)
const _hoisted_44 = {
  key: 1,
  class: "m-roadmap-summary-item"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "m-blue pair" }, "闲对", -1)
const _hoisted_46 = { class: "prediction-wrap" }
const _hoisted_47 = { class: "roadmap-summary-wrap" }
const _hoisted_48 = { class: "roadmap-summary-item" }
const _hoisted_49 = { class: "red" }
const _hoisted_50 = { class: "roadmap-summary-item" }
const _hoisted_51 = { class: "blue" }
const _hoisted_52 = { class: "roadmap-summary-item" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "green" }, "和", -1)
const _hoisted_54 = {
  key: 0,
  class: "roadmap-summary-item"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "red pair" }, "对", -1)
const _hoisted_56 = {
  key: 1,
  class: "roadmap-summary-item"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "blue pair" }, "对", -1)
const _hoisted_58 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_app_svg = _resolveComponent("app-svg")
  const _component_good_road_btn_svg = _resolveComponent("good-road-btn-svg")
  const _component_pop_alert_view = _resolveComponent("pop-alert-view")
  const _component_mobile_bet_view = _resolveComponent("mobile-bet-view")
  const _component_m_prediction = _resolveComponent("m-prediction")
  const _component_d_prediction_sumary_view = _resolveComponent("d-prediction-sumary-view")
  const _component_road_map_view = _resolveComponent("road-map-view")
  const _component_m_card_result_view = _resolveComponent("m-card-result-view")
  const _component_marquee_text = _resolveComponent("marquee-text")
  const _component_mobile_switch_table_view = _resolveComponent("mobile-switch-table-view")
  const _component_m_good_road_panel = _resolveComponent("m-good-road-panel")
  const _component_mobile_setting_dialog_view = _resolveComponent("mobile-setting-dialog-view")
  const _component_custom_money_view = _resolveComponent("custom-money-view")
  const _component_limit_dialog_view = _resolveComponent("limit-dialog-view")
  const _component_change_password_view = _resolveComponent("change-password-view")
  const _component_bet_history = _resolveComponent("bet-history")
  const _component_red_envelop_2 = _resolveComponent("red-envelop-2")
  const _component_rule_view = _resolveComponent("rule-view")

  return (_openBlock(), _createBlock("div", _hoisted_3, [
    _createVNode("div", _hoisted_4, [
      _createVNode("div", {
        class: "info-3",
        onClick: _cache[1] || (_cache[1] = 
                () => {
                    _ctx.showSwicthTable = true
                    _ctx.showGoodRoadPanel = false
                }
            )
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("span", _hoisted_9, _toDisplayString(_ctx.userId), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_app_svg, {
          box: '0 0 18.067 18.066',
          id: 'coin',
          className: 'coin-svg',
          fill: 'rgb(221, 194, 140)',
          stroke: 'rgb(221, 194, 140)'
        }, null, 8, ["box", "fill", "stroke"]),
        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.betCoin), 1)
      ]),
      _createVNode("div", {
        class: "info-good-road",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OnShowGoodRoad && _ctx.OnShowGoodRoad(...args)))
      }, [
        _createVNode(_component_good_road_btn_svg, {
          count: _ctx.goodRoadCount,
          class: "good-road-btn-svg"
        }, null, 8, ["count"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("span", {
          class: "icon icon-home",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToLoby && _ctx.goToLoby(...args)))
        }),
        _createVNode("span", {
          class: "icon icon-setting",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSettings = true))
        })
      ])
    ]),
    _hoisted_13,
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        (_ctx.videoIsLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "table-limit",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLimitDialog = true))
        }, _toDisplayString(_ctx.iN('desk.limit')) + " " + _toDisplayString(_ctx.redLimit), 1),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", null, [
            _createVNode("span", {
              class: ["timer", [
                            _ctx.timerColor,
                            _ctx.currentCount < 11 && _ctx.currentCount > -1
                                ? 'pulsing'
                                : ''
                        ]]
            }, _toDisplayString(_ctx.currentCount != -1 ? _ctx.currentCount : ''), 3),
            _createVNode("span", _hoisted_21, _toDisplayString(_ctx.currentCount > -1
                                ? _ctx.iN('desk.startbet')
                                : _ctx.iN('desk.nobet')), 1)
          ]),
          _createVNode("div", _hoisted_22, "ID：" + _toDisplayString(_ctx.deskGameId), 1),
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.iN('desk.shoe')) + ": " + _toDisplayString(_ctx.shoe) + "/" + _toDisplayString(_ctx.juNo), 1)
        ]),
        (_ctx.gameType === 'G002')
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: ["super-6-switcher", { 'is-disabled': _ctx.hasConfirmedBet }]
            }, [
              _createVNode("span", {
                class: { active: !_ctx.isSuper6Mode },
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSuper6Mode(false)))
              }, "百家乐", 2),
              _createVNode("span", {
                class: { active: _ctx.isSuper6Mode },
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleSuper6Mode(true)))
              }, "免水百家乐", 2)
            ], 2))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fadein-out" }, {
          default: _withId(() => [
            (_ctx.messageCounter > 0)
              ? (_openBlock(), _createBlock(_component_pop_alert_view, {
                  key: 0,
                  class: "pop-alert-view",
                  mdata: _ctx.alertMessage
                }, null, 8, ["mdata"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_24, [
        _createVNode(_component_mobile_bet_view, {
          class: "bet-view",
          gameType: _ctx.gameType,
          chipValue: _ctx.chip,
          allowBet: _ctx.allowBet,
          s6Mode: _ctx.isSuper6Mode,
          onBetSuccess: _ctx.handleOnBetSuccess,
          ref: "betview",
          key: _ctx.betViewKey
        }, null, 8, ["gameType", "chipValue", "allowBet", "s6Mode", "onBetSuccess"]),
        _createVNode("div", _hoisted_25, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chips, (chpAmt, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "chip-container",
              key: i
            }, [
              (_ctx.chipIndex === i)
                ? (_openBlock(), _createBlock("img", _hoisted_26))
                : _createCommentVNode("", true),
              _createVNode("picture", {
                class: "chip",
                onClick: ($event: any) => (_ctx.chipClicked(i, chpAmt))
              }, [
                _createVNode("source", {
                  type: "image/webp",
                  srcset: _ctx.getChipImageWebp(chpAmt)
                }, null, 8, ["srcset"]),
                _createVNode("img", {
                  src: _ctx.getChipImageWebpPng(chpAmt),
                  "data-was-processed": "true",
                  "data-src": _ctx.getChipImageWebpPng(chpAmt),
                  draggable: "false"
                }, null, 8, ["src", "data-src"])
              ], 8, ["onClick"])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_27, [
            (_ctx.chipIndex === 5)
              ? (_openBlock(), _createBlock("img", _hoisted_28))
              : _createCommentVNode("", true),
            _createVNode("picture", {
              class: "chip",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showChipDialog(false))),
              draggable: "false"
            }, [
              _hoisted_29,
              _hoisted_30,
              _createVNode("span", null, _toDisplayString(_ctx.getCustomChipValue()), 1)
            ])
          ]),
          _createVNode("picture", {
            class: "chip-setting",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showChipDialog(true)))
          }, [
            _hoisted_31,
            _hoisted_32
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      _createVNode("div", _hoisted_34, [
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("span", _hoisted_37, _toDisplayString(_ctx.gameType === 'G002' ? '庄' : '龙'), 1),
            _createVNode("span", null, ": " + _toDisplayString(_ctx.redCount), 1)
          ]),
          _createVNode("div", _hoisted_38, [
            _createVNode("span", _hoisted_39, _toDisplayString(_ctx.gameType === 'G002' ? '闲' : '虎'), 1),
            _createVNode("span", null, ": " + _toDisplayString(_ctx.blueCount), 1)
          ]),
          _createVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode("span", null, ": " + _toDisplayString(_ctx.greenCount), 1)
          ]),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _hoisted_43,
                _createVNode("span", null, ": " + _toDisplayString(_ctx.redPairCount), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("div", _hoisted_44, [
                _hoisted_45,
                _createVNode("span", null, ": " + _toDisplayString(_ctx.bluePairCount), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_m_prediction, {
          class: "item-pre",
          label: _ctx.gameType === 'G002' ? '庄' : '龙',
          color: 2,
          preType: 1,
          preData: _ctx.nextBlueRoadMapSummaryData,
          isHorizontal: false,
          onOnpredict: _ctx.handleOnPredict
        }, null, 8, ["label", "preData", "onOnpredict"]),
        _createVNode(_component_m_prediction, {
          class: "item-pre n2",
          label: _ctx.gameType === 'G002' ? '闲' : '虎',
          color: 1,
          preType: 2,
          preData: _ctx.nextRedRoadMapSummaryData,
          isHorizontal: false,
          onOnpredict: _ctx.handleOnPredict
        }, null, 8, ["label", "preData", "onOnpredict"])
      ]),
      _createVNode("div", _hoisted_46, [
        _createVNode(_component_d_prediction_sumary_view, {
          class: "item-pre",
          label: _ctx.gameType === 'G002' ? '庄' : '龙',
          color: 2,
          preType: 1,
          preData: _ctx.nextBlueRoadMapSummaryData,
          isHorizontal: false,
          onOnpredict: _ctx.handleOnPredict
        }, null, 8, ["label", "preData", "onOnpredict"]),
        _createVNode(_component_d_prediction_sumary_view, {
          class: "item-pre",
          label: _ctx.gameType === 'G002' ? '闲' : '虎',
          color: 1,
          preType: 2,
          preData: _ctx.nextRedRoadMapSummaryData,
          isHorizontal: false,
          onOnpredict: _ctx.handleOnPredict
        }, null, 8, ["label", "preData", "onOnpredict"])
      ]),
      _createVNode(_component_road_map_view, {
        class: "roadmap",
        display: _ctx.roadmapDisplay,
        gameType: _ctx.gameType,
        mapData: _ctx.tableResult,
        predictionEnabled: true,
        beadRowsCount: _ctx.roadmapDisplay === 6 ? 7 : 13,
        onRoadMapData: _ctx.UpdateRoadMapData,
        ref: "roadmapview",
        key: _ctx.roadMapKey
      }, null, 8, ["display", "gameType", "mapData", "beadRowsCount", "onRoadMapData"]),
      _createVNode("div", _hoisted_47, [
        _createVNode("div", _hoisted_48, [
          _createVNode("span", _hoisted_49, _toDisplayString(_ctx.gameType === 'G002' ? '庄' : '龙'), 1),
          _createVNode("span", null, _toDisplayString(_ctx.redCount), 1)
        ]),
        _createVNode("div", _hoisted_50, [
          _createVNode("span", _hoisted_51, _toDisplayString(_ctx.gameType === 'G002' ? '闲' : '虎'), 1),
          _createVNode("span", null, _toDisplayString(_ctx.blueCount), 1)
        ]),
        _createVNode("div", _hoisted_52, [
          _hoisted_53,
          _createVNode("span", null, _toDisplayString(_ctx.greenCount), 1)
        ]),
        (_ctx.gameType === 'G002')
          ? (_openBlock(), _createBlock("div", _hoisted_54, [
              _hoisted_55,
              _createVNode("span", null, _toDisplayString(_ctx.redPairCount), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.gameType === 'G002')
          ? (_openBlock(), _createBlock("div", _hoisted_56, [
              _hoisted_57,
              _createVNode("span", null, _toDisplayString(_ctx.bluePairCount), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showPokerCards)
        ? (_openBlock(), _createBlock(_component_m_card_result_view, {
            key: 0,
            class: "d-card-result-view",
            gameType: _ctx.gameType,
            gameResult: _ctx.currentGameResult
          }, null, 8, ["gameType", "gameResult"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_58, [
      _createVNode(_component_marquee_text, {
        class: "m-notice",
        key: _ctx.deskInfoKey,
        animate: !_ctx.noticeIsPaused,
        speed: 30
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.deskNotice), 1)
        ]),
        _: 1
      }, 8, ["animate"])
    ]),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withId(() => [
        (_ctx.showSwicthTable)
          ? (_openBlock(), _createBlock(_component_mobile_switch_table_view, {
              key: 0,
              class: "full-dialog",
              onOnHideSwitchTable: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSwicthTable = false)),
              onOnSwitchTable: _ctx.onSwitchTable
            }, null, 8, ["onOnSwitchTable"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-right" }, {
      default: _withId(() => [
        (_ctx.showGoodRoadPanel)
          ? (_openBlock(), _createBlock(_component_m_good_road_panel, {
              key: 0,
              class: "good-road-panel",
              onOnHideGoodRoad: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showGoodRoadPanel = false)),
              onOnGoodRoadSync: _ctx.onGoodRoadSync
            }, null, 8, ["onOnGoodRoadSync"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createBlock(_component_mobile_setting_dialog_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showSettings = false)),
              onOnShowChangePasswordForm: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPasswordForm = true)),
              onOnShowHistory: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showHistory = true)),
              onOnShowRule: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showRule = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showCustumChip)
          ? (_openBlock(), _createBlock(_component_custom_money_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showCustumChip = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showLimitDialog)
          ? (_openBlock(), _createBlock(_component_limit_dialog_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showLimitDialog = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordForm)
          ? (_openBlock(), _createBlock(_component_change_password_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPasswordForm = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(_component_bet_history, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showHistory = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showPacket2)
          ? (_openBlock(), _createBlock(_component_red_envelop_2, {
              key: 0,
              class: "full-dialog",
              redpackets: _ctx.packet2s,
              onClose: _ctx.onPacket2Close
            }, null, 8, ["redpackets", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showRule)
          ? (_openBlock(), _createBlock(_component_rule_view, {
              key: 0,
              class: "full-dialog",
              onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showRule = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})